<template>
  <fragment>
    <v-container fluid pa-0>

      <v-layout justify-center column fill-height>
        <template>
            <CContainer>
              <CRow>
                <CCol sm="3" class="py-0">
                  <Label label="会員属性" name="user_type" />
                </CCol>
                <CCol class="py-0">
                <SelectField
                        v-model="input && input['user_type']"
                        name="user_type"
                        label="会員属性"
                        :options="user_types"
                        text-key="label"
                        value-key="value"
                        :multiple="false"
                />
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="3" class="py-0">
                  <Label label="性別" name="sex" />
                </CCol>
                <CCol class="py-0">
                <SelectField
                        v-model="input && input['sex']"
                        name="sex"
                        label="性別"
                        :options="genders"
                        text-key="label"
                        value-key="value"
                        :multiple="false"
                />
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="3" class="py-0">
                  <Label label="生年月日" name="birth_date" />
                </CCol>
                <CCol class="py-0">
                <DateField v-model="input && input['birth_date']" name="生年月日" label="birth_date" />
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="3" class="py-0">
                  <Label label="店舗所在地(大)" name="large_location" />
                </CCol>
                <CCol class="py-0">
                <SelectField
                        v-model="input && input['large_location']"
                        name="large_location"
                        label="店舗所在地(大)"
                        :options="large_locations"
                        text-key="label"
                        value-key="value"
                        :multiple="false"
                />
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="3" class="py-0">
                  <Label label="店舗所在地(中)" name="medium_location" />
                </CCol>
                <CCol class="py-0">
                <SelectField
                        v-model="input && input['medium_location']"
                        name="medium_location"
                        label="店舗所在地(中)"
                        :options="medium_locations"
                        text-key="label"
                        value-key="value"
                        :multiple="false"
                />
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="3" class="py-0">
                  <Label label="店舗業態(大)" name="biz_large_category" />
                </CCol>
                <CCol class="py-0">
                <SelectField
                        v-model="input && input['biz_large_category']"
                        name="biz_large_category"
                        label="店舗業態(大)"
                        :options="biz_large_categories"
                        text-key="label"
                        value-key="value"
                        :multiple="false"
                />
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="3" class="py-0">
                  <Label label="店舗業態(中)" name="biz_medium_category" />
                </CCol>
                <CCol class="py-0">
                <SelectField
                        v-model="input && input['biz_medium_category']"
                        name="biz_medium_category"
                        label="店舗業態(中)"
                        :options="biz_medium_categories"
                        text-key="label"
                        value-key="value"
                        :multiple="false"
                />
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="3" class="py-0">
                  <Label label="店舗規模(店舗数)" name="business_scale" />
                </CCol>
                <CCol class="py-0">
                <SelectField
                        v-model="input && input['business_scale']"
                        name="business_scale"
                        label="店舗規模(店舗数)"
                        :options="business_scales"
                        text-key="label"
                        value-key="value"
                        :multiple="false"
                />
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="3" class="py-0">
                  <Label label="主要店舗展開エリア" name="business_area" />
                </CCol>
                <CCol class="py-0">
                <SelectField
                        v-model="input && input['business_area']"
                        name="business_area"
                        label="主要店舗展開エリア"
                        :options="business_areas"
                        text-key="label"
                        value-key="value"
                        :multiple="false"
                />
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="3" class="py-0">
                  <Label label="ランチ営業有無" name="lunch_menu" />
                </CCol>
                <CCol class="py-0">
                <SelectField
                        v-model="input && input['lunch_menu']"
                        name="lunch_menu"
                        label="ランチ営業有無"
                        :options="lunch_menus"
                        text-key="label"
                        value-key="value"
                        :multiple="false"
                />
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="3" class="py-0">
                  <Label label="会員状態" name="plan_num" />
                </CCol>
                <CCol class="py-0">
                <SelectField
                        v-model="input && input['plan_num']"
                        name="plan_num"
                        label="会員状態"
                        :options="plan_nums"
                        text-key="label"
                        value-key="value"
                        :multiple="false"
                />
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="3" class="py-0">
                  <Label label="最終ログイン日時" name="logged_in_at" />
                </CCol>
                <CCol class="py-0">
                <DateTimeField
                        v-model="input && input['logged_in_at']"
                        name="logged_in_at"
                        label="最終ログイン日時"
                />
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="3" class="py-0">
                  <Label label="ユーザID(カンマ区切り)" name="user_ids" />
                </CCol>
                <CCol class="py-0">
                  <TextField
                          v-model="input && input['user_ids']"
                          name="user_ids"
                          label="ユーザID(カンマ区切り)"
                  />
                </CCol>
              </CRow>
            </CContainer>
            <div v-if="conditionError" class="invalid-feedback" style="display: inline">配信先条件は必須です</div>
        </template>
      </v-layout>
    </v-container>

  </fragment>
</template>

<script>
import SelectField from "./select";
import DateField from "./date";
import DateTimeField from "./datetime";
import Label from "./label";
import TextField from "./text";

export default {
  components: {
    SelectField,
    DateField,
    DateTimeField,
    Label,
    TextField
  },
  props: {
    input: {
      type: Object,
      default: () => {}
    },
    mode: {
      type: String,
      default: "edit",
      validator: value => ["show", "create", "edit"].indexOf(value) !== -1
    },
    rules: {
      type: String,
      default: ""
    },
    conditionError: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    };
  },
  computed: {
    isShowMode() {
      return this.mode === "show";
    },
    isCreateMode() {
      return this.mode === "create";
    },
    isEditMode() {
      return this.mode === "edit";
    },
    user_types() {
      let nullOption = [{value: null, label: '---'}]

      this.$store.getters[`common/user_types/options/options`].forEach((option) => {
        nullOption.push({
            value: option.value,
            label: option.label,
        })
      });
      return nullOption || [];
    },
    genders() {
      let nullOption = [{value: null, label: '---'}]

      this.$store.getters[`common/genders/options/options`].forEach((option) => {
        nullOption.push({
            value: option.value,
            label: option.label,
        })
      })
      return nullOption || [];
    },
    large_locations() {
      let nullOption = [{value: null, label: '---'}]

      this.$store.getters[`common/large_locations/options/options`].forEach((option) => {
        nullOption.push({
            value: option.value,
            label: option.label,
        })
      })
      return nullOption || [];
    },
    medium_locations() {
      let nullOption = [{value: null, label: '---'}]

      this.$store.getters[`common/medium_locations/options/options`].forEach((option) => {
        nullOption.push({
            value: option.value,
            label: option.label,
        })
      })
      return nullOption || [];
    },
    biz_large_categories() {
      let nullOption = [{value: null, label: '---'}]

      this.$store.getters[`common/biz_large_categories/options/options`].forEach((option) => {
        nullOption.push({
            value: option.value,
            label: option.label,
        })
      })
      return nullOption || [];
    },
    biz_medium_categories() {
      let nullOption = [{value: null, label: '---'}]

      this.$store.getters[`common/biz_medium_categories/options/options`].forEach((option) => {
        nullOption.push({
            value: option.value,
            label: option.label,
        })
      })
      return nullOption || [];
    },
    business_scales() {
      let nullOption = [{value: null, label: '---'}]

      this.$store.getters[`common/business_scales/options/options`].forEach((option) => {
        nullOption.push({
            value: option.value,
            label: option.label,
        })
      })
      return nullOption || [];
    },
    business_areas() {
      let nullOption = [{value: null, label: '---'}]

      this.$store.getters[`common/business_areas/options/options`].forEach((option) => {
        nullOption.push({
            value: option.value,
            label: option.label,
        })
      })
      return nullOption || [];
    },
    lunch_menus() {
      let nullOption = [{value: null, label: '---'}]

      this.$store.getters[`common/lunch_menus/options/options`].forEach((option) => {
        nullOption.push({
            value: option.value,
            label: option.label,
        })
      })
      return nullOption || [];
    },
    plan_nums() {
      let nullOption = [{value: null, label: '---'}]

      this.$store.getters[`common/plan_nums/options/options`].forEach((option) => {
        nullOption.push({
            value: option.value,
            label: option.label,
        })
      })
      return nullOption || [];
    }
  },
  watch: {
    "input.large_location": {
      handler(value) {
        if (this.input.large_location !== null) {
          this.$store.dispatch(
            `common/medium_locations/options/index`,
            this.input.large_location
          );
        }
      }
    },
    "input.biz_large_category": {
      handler(value) {
        if (this.input.biz_large_category !== null) {
          this.$store.dispatch(
            `common/biz_medium_categories/options/index`,
            this.input.biz_large_category
          );
        }
      }
    }
  },
  methods: {
  },
  created(){
    this.$store.dispatch(`common/user_types/options/index`);
    this.$store.dispatch(`common/genders/options/index`);
    this.$store.dispatch(`common/large_locations/options/index`);
    // this.$store.dispatch(`common/medium_locations/options/index`);
    this.$store.dispatch(`common/biz_large_categories/options/index`);
    // this.$store.dispatch(`common/biz_medium_categories/options/index`);
    this.$store.dispatch(`common/business_scales/options/index`);
    this.$store.dispatch(`common/business_areas/options/index`);
    this.$store.dispatch(`common/lunch_menus/options/index`);
    this.$store.dispatch(`common/plan_nums/options/index`);

  }
};
</script>
<style module lang="scss">
.content-card {
  margin: 5px 0;
}
</style>
